module.exports = __webpack_public_path__ + "img/zfbg.02e7c24e.png";